import axios from 'axios';
import { APP_APIGATEWAY_ENDPOINT } from '@env';
axios.defaults.baseURL = APP_APIGATEWAY_ENDPOINT;

const get = async (url: string): Promise<any> => {
    axios.defaults.withCredentials = false;
    console.log(`[GET] ${url}`);

    const getProps = [url];

    try {
        return await axios.get(...(getProps as [string, object?]));
    } catch (error) {
        console.log(error);
    }
};

const post = async (url: string, data: any): Promise<any> => {
    axios.defaults.withCredentials = false;
    console.log('[POST]', url, data);

    const postProps = [url, data];

    try {
        return await axios.post(...(postProps as [string, object?, object?]));
    } catch (error) {
        console.error(error);
    }
};

export { axios, get, post };
